module.exports = __webpack_public_path__ + "static/media/exhibition.7fb9932a.jpg";